import * as React from 'react';
import { articleSearchContext } from './context';

export const ArticleSearchProvider = (props: React.PropsWithChildren<{
  initialValue?: string,
  onChange?: (value: string) => void,
}>) => {
  const {
    initialValue,
    onChange,
    children,
  } = props;
  const handlers = React.useState(initialValue ?? '');
  const [value] = handlers;
  React.useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [value, onChange]);
  return (
    <articleSearchContext.Provider
      value={handlers}
    >
      {children}
    </articleSearchContext.Provider>
  );
};
